import React from 'react';
import ComboSelect from 'react-combo-select';

class Co2CostCal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          mount:0,
          cost:0
        };
//        fetch('https://ecofestivalcalculate.du.r.appspot.com/getCofficient')
//            .then(res=>res.json())
//            .then(data=>co2CoefficientArr=data.arr);
    }
    fn_CalCo2Cost = (e) => {
      console.log("handlecount");
      this.setState({mount: e.target.value});
  }
  fn_convertNum = (mount) => {
    let cost =  mount * 18000;
    cost = cost.toString();
    cost = cost.replace(/[^0-9]/g,'');   // 입력값이 숫자가 아니면 공백
    cost = cost.replace(/,/g,'');          // ,값 공백처리
    cost = cost.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // 정규식을 이용해서 3자리 마다 , 추가
    return cost;
  }



  render() {
    let resultCost = this.fn_convertNum(this.state.mount);

    return (
      <div className="main_body_content">
        <h4>
          탄소배출권 거래 가격 계산하기
        </h4>
        <div style={co2CostDiv}>
        <input id="inputCount" style={countInputstyle} onChange={this.fn_CalCo2Cost} type="number" name="count" placeholder="총 CO₂ 배출량(톤)"/>
        <h2>
        X  50,000원  = {resultCost} 원
        </h2>
        </div>
        <div>
          <h6>
          **2023년 기준 탄소배출권 1t 당 50,000원
          </h6>
        </div>
      </div>

    );
  }
}

const countInputstyle ={
  height :"40px",
  width:"150px",
  marginLeft:"20px",
  marginRight:"20px",
  float:"right"
}
const co2CostDiv ={
  justifyContent: "center",
  alignItems: "center",
  display:"flex",
  flexDirection: "row",

}



Co2CostCal.defaultProps = {
};

export default Co2CostCal;
